import PropTypes from 'prop-types';
import React from 'react';

import FacebookIcon from '../../../../static/icons/social-buttons-facebook.svg';
import InstagramIcon from '../../../../static/icons/social-buttons-instagram.svg';
import TwitterIcon from '../../../../static/icons/social-buttons-twitter.svg';
import WebsiteIcon from '../../../../static/icons/social-buttons-website.svg';
import { BackstageContentSections } from '../../../constants/ContentSections';
import * as D from '../deps';

import BackstageSocialLinkButton from './BackstageSocialLinkButton';

import './BackstageSocialLinkButtonRow.scss';

const BackstageSocialLinkButtonRow = props => {
  return (
    <div className='SocialLinkButtonRow'>
      <BackstageSocialLinkButton
        text={'Twitter'}
        link={props.twitterUrl}
        svg={TwitterIcon}
        isButtonWhite={props.hasBackgroundImg}
      />
      <BackstageSocialLinkButton
        text={'Instagram'}
        link={props.instagramUrl}
        svg={InstagramIcon}
        isButtonWhite={props.hasBackgroundImg}
      />
      <BackstageSocialLinkButton
        text={'Facebook'}
        link={props.facebookUrl}
        svg={FacebookIcon}
        isButtonWhite={props.hasBackgroundImg}
      />
      <BackstageSocialLinkButton
        text={'Website'}
        link={props.websiteUrl}
        svg={WebsiteIcon}
        isButtonWhite={props.hasBackgroundImg}
      />
    </div>
  );
};

BackstageSocialLinkButtonRow.propTypes = {
  hasBackgroundImg: PropTypes.bool,
  twitterUrl: PropTypes.string,
  instagramUrl: PropTypes.string,
  facebookUrl: PropTypes.string,
  websiteUrl: PropTypes.string,
};

export const BackstageSocialLinkButtonRowWithLogger = D.withVisibilityLogger(
  { contentSection: BackstageContentSections.SOCIAL_LINKS },
  { useMemo: true },
)(BackstageSocialLinkButtonRow);

export default BackstageSocialLinkButtonRowWithLogger;
